package com.veldekar.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Video

@Composable
fun SessionMediaItem(
    image: String? = null,
    linkImage: String? = null,
    video: String? = null,
    invertForDarkMode: Boolean = false,
    ocrText: String? = null,
    description: String? = null,
    width: Int? = null,
    height: Int? = null,
) {
    Div(Modifier.position(Position.Relative).fillMaxWidth().toAttrs()) {
        if (ocrText != null) {
            SpanText(
                ocrText,
                modifier = Modifier
                    .position(Position.Absolute)
                    .opacity(0f)
                    .width(1.px)
                    .height(1.px)
                    .overflow(Overflow.Hidden)
            )
        }
        if (image != null) {
            val altText = description ?: ""
            val imgModifier = Modifier.maxWidth(100.percent).then(
                if (width == null || height == null) {
                    Modifier
                } else {
                    Modifier.width(width.px).height(height.px).styleModifier {
                        property("aspect-ratio", "$width / $height")
                        property("height", "auto")
                    }
                }
            )

            if (invertForDarkMode) {
                InvertibleImage(image, linkImage ?: "", altText = altText, width = width, height = height)
            } else if (linkImage != null && linkImage != image) {
                A(href = linkImage) {
                    LazyImg(
                        src = image,
                        alt = altText,
                        width = width,
                        height = height,
                        modifier = imgModifier
                    )
                }
            } else {
                LazyImg(
                    src = image,
                    alt = altText,
                    width = width,
                    height = height,
                    modifier = imgModifier
                )
            }
        } else if (video != null) {
            if (video.contains("youtube.com") || video.contains("youtu.be")) {
                YouTubeVideo(video)
            } else {
                Video(
                    attrs = {
                        attr("src", video)
                        attr("controls", "")
                    }
                ) {}
            }
        }
    }
}
